/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { marketingConsentControllerCreateV1 } from '../fn/marketing-consent/marketing-consent-controller-create-v-1';
import { MarketingConsentControllerCreateV1$Params } from '../fn/marketing-consent/marketing-consent-controller-create-v-1';
import { marketingConsentControllerDeleteV1 } from '../fn/marketing-consent/marketing-consent-controller-delete-v-1';
import { MarketingConsentControllerDeleteV1$Params } from '../fn/marketing-consent/marketing-consent-controller-delete-v-1';
import { marketingConsentControllerFindAllV1 } from '../fn/marketing-consent/marketing-consent-controller-find-all-v-1';
import { MarketingConsentControllerFindAllV1$Params } from '../fn/marketing-consent/marketing-consent-controller-find-all-v-1';
import { marketingConsentControllerFindByContactV1 } from '../fn/marketing-consent/marketing-consent-controller-find-by-contact-v-1';
import { MarketingConsentControllerFindByContactV1$Params } from '../fn/marketing-consent/marketing-consent-controller-find-by-contact-v-1';
import { marketingConsentControllerFindByIdV1 } from '../fn/marketing-consent/marketing-consent-controller-find-by-id-v-1';
import { MarketingConsentControllerFindByIdV1$Params } from '../fn/marketing-consent/marketing-consent-controller-find-by-id-v-1';
import { marketingConsentControllerSearchCursorV1 } from '../fn/marketing-consent/marketing-consent-controller-search-cursor-v-1';
import { MarketingConsentControllerSearchCursorV1$Params } from '../fn/marketing-consent/marketing-consent-controller-search-cursor-v-1';
import { marketingConsentControllerSearchV1 } from '../fn/marketing-consent/marketing-consent-controller-search-v-1';
import { MarketingConsentControllerSearchV1$Params } from '../fn/marketing-consent/marketing-consent-controller-search-v-1';
import { marketingConsentControllerUpdateV1 } from '../fn/marketing-consent/marketing-consent-controller-update-v-1';
import { MarketingConsentControllerUpdateV1$Params } from '../fn/marketing-consent/marketing-consent-controller-update-v-1';
import { MarketingConsentDto } from '../models/marketing-consent-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class MarketingConsentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `marketingConsentControllerSearchV1()` */
  static readonly MarketingConsentControllerSearchV1Path = '/api/v1/marketing-consent/search';

  /**
   * 마케팅 동의 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marketingConsentControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerSearchV1$Response(params?: MarketingConsentControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<MarketingConsentDto>;
}>> {
    return marketingConsentControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 마케팅 동의 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marketingConsentControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerSearchV1(params?: MarketingConsentControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<MarketingConsentDto>;
}> {
    return this.marketingConsentControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<MarketingConsentDto>;
}>): OffsetPaginationDto & {
'items'?: Array<MarketingConsentDto>;
} => r.body)
    );
  }

  /** Path part for operation `marketingConsentControllerSearchCursorV1()` */
  static readonly MarketingConsentControllerSearchCursorV1Path = '/api/v1/marketing-consent/search/cursor';

  /**
   * 마케팅 동의 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marketingConsentControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerSearchCursorV1$Response(params?: MarketingConsentControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<MarketingConsentDto>;
}>> {
    return marketingConsentControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 마케팅 동의 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marketingConsentControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerSearchCursorV1(params?: MarketingConsentControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<MarketingConsentDto>;
}> {
    return this.marketingConsentControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<MarketingConsentDto>;
}>): CursorPaginationDto & {
'items'?: Array<MarketingConsentDto>;
} => r.body)
    );
  }

  /** Path part for operation `marketingConsentControllerFindByContactV1()` */
  static readonly MarketingConsentControllerFindByContactV1Path = '/api/v1/marketing-consent/contact/{contact}';

  /**
   * 연락처로 마케팅 동의 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marketingConsentControllerFindByContactV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerFindByContactV1$Response(params: MarketingConsentControllerFindByContactV1$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingConsentDto>> {
    return marketingConsentControllerFindByContactV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 연락처로 마케팅 동의 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marketingConsentControllerFindByContactV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerFindByContactV1(params: MarketingConsentControllerFindByContactV1$Params, context?: HttpContext): Observable<MarketingConsentDto> {
    return this.marketingConsentControllerFindByContactV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<MarketingConsentDto>): MarketingConsentDto => r.body)
    );
  }

  /** Path part for operation `marketingConsentControllerFindAllV1()` */
  static readonly MarketingConsentControllerFindAllV1Path = '/api/v1/marketing-consent';

  /**
   * 모든 마케팅 동의 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marketingConsentControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerFindAllV1$Response(params?: MarketingConsentControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MarketingConsentDto>>> {
    return marketingConsentControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 마케팅 동의 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marketingConsentControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerFindAllV1(params?: MarketingConsentControllerFindAllV1$Params, context?: HttpContext): Observable<Array<MarketingConsentDto>> {
    return this.marketingConsentControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MarketingConsentDto>>): Array<MarketingConsentDto> => r.body)
    );
  }

  /** Path part for operation `marketingConsentControllerCreateV1()` */
  static readonly MarketingConsentControllerCreateV1Path = '/api/v1/marketing-consent';

  /**
   * 마케팅 동의 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marketingConsentControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  marketingConsentControllerCreateV1$Response(params: MarketingConsentControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingConsentDto>> {
    return marketingConsentControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 마케팅 동의 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marketingConsentControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  marketingConsentControllerCreateV1(params: MarketingConsentControllerCreateV1$Params, context?: HttpContext): Observable<MarketingConsentDto> {
    return this.marketingConsentControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<MarketingConsentDto>): MarketingConsentDto => r.body)
    );
  }

  /** Path part for operation `marketingConsentControllerFindByIdV1()` */
  static readonly MarketingConsentControllerFindByIdV1Path = '/api/v1/marketing-consent/{id}';

  /**
   * 마케팅 동의 id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marketingConsentControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerFindByIdV1$Response(params: MarketingConsentControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingConsentDto>> {
    return marketingConsentControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 마케팅 동의 id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marketingConsentControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerFindByIdV1(params: MarketingConsentControllerFindByIdV1$Params, context?: HttpContext): Observable<MarketingConsentDto> {
    return this.marketingConsentControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<MarketingConsentDto>): MarketingConsentDto => r.body)
    );
  }

  /** Path part for operation `marketingConsentControllerDeleteV1()` */
  static readonly MarketingConsentControllerDeleteV1Path = '/api/v1/marketing-consent/{id}';

  /**
   * 마케팅 동의 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marketingConsentControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerDeleteV1$Response(params: MarketingConsentControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return marketingConsentControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 마케팅 동의 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marketingConsentControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marketingConsentControllerDeleteV1(params: MarketingConsentControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.marketingConsentControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `marketingConsentControllerUpdateV1()` */
  static readonly MarketingConsentControllerUpdateV1Path = '/api/v1/marketing-consent/{id}';

  /**
   * 마케팅 동의 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marketingConsentControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  marketingConsentControllerUpdateV1$Response(params: MarketingConsentControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingConsentDto>> {
    return marketingConsentControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 마케팅 동의 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marketingConsentControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  marketingConsentControllerUpdateV1(params: MarketingConsentControllerUpdateV1$Params, context?: HttpContext): Observable<MarketingConsentDto> {
    return this.marketingConsentControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<MarketingConsentDto>): MarketingConsentDto => r.body)
    );
  }

}
